import ShareableLinkDocuments from './ShareableLinkDocuments.page';

export default ShareableLinkDocuments;
